import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const courseTypePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  isIgnored: PropTypes.bool.isRequired,
  isDefaultFilter: PropTypes.bool.isRequired,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
  rearrangementScore: PropTypes.number,
  node: nodePropType.isRequired,
})

courseTypePropType.defaultProps = {
  synonyms: undefined,
  isExcludedFromSearch: false,
  description: undefined,
  rearrangementScore: undefined,
}

export default courseTypePropType
